import axios from 'axios';
import config from './config';

const API_URL = `${config.API_BASE_URL}/cities`;

export const fetchCities = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching cities:', error);
    throw error;
  }
};

export const createCity = async (cityName) => {
  try {
    const response = await axios.post(API_URL, { Name: cityName });
    return response.data;
  } catch (error) {
    console.error('Error creating city:', error);
    throw error;
  }
};

export const deleteCity = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting city:', error);
    throw error;
  }
};
